"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InlineIconProptypes = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.string,
    selected: _propTypes.bool,
    onChange: _propTypes.func,
    text: _propTypes.string,
    vertical: _propTypes.bool,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    color: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    icon: _propTypes.any,
    viewport: _propTypes.string,
    isReversed: _propTypes.bool,
    isFullWidth: _propTypes.bool,
    textColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    boldText: _propTypes.bool,
    hideButton: _propTypes.bool,
    subText: _propTypes.string,
    subTextColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    disabled: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    selected: false,
    onChange: function onChange() {},
    text: '',
    vertical: false,
    accessible: true,
    isReversed: false,
    isFullWidth: false,
    color: 'secondary',
    textColor: 'neutral',
    boldText: false,
    hideButton: false,
    subTextColor: 'greyDark',
    disabled: false
  }
};
exports.default = _default;
var InlineIconProptypes = {
  PropTypes: {
    icon: _propTypes.any
  }
};
exports.InlineIconProptypes = InlineIconProptypes;